import React, { useState } from "react";
import {
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { AiFillCloseCircle } from "react-icons/ai";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { BiX } from "react-icons/bi";
import { applyTrivvyTitleText, getTrivvyTitleText } from '../data'

export default function RenamePopup({ onClose, open, item, onUpdateItem }) {
  const originalName = getTrivvyTitleText(item);
  const [name, setName] = useState(originalName);

  const handleRename = () => {
    if (name === originalName) {
      onClose();
      return;
    }
    axios
      .put(url.editTrivia(item._id), {
        // The new text is folded back into the stored markup so the styling
        // applied on the edit page survives a rename.
        updateData: { name: applyTrivvyTitleText(item.name, name) },
      })
      .then(({ data }) => {
        const updated = data.data.trivia;
        console.log({ updated });
        onUpdateItem(updated);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <Modal isOpen={open} size="sm" centered className="bwai-modal">
      <ModalHeader
        className="bwai_modal_header"
        close={
          <BiX
            className="cursor-pointer"
            color="gray"
            size={30}
            onClick={() => onClose()}
          />
        }
      >
        <span className="bwai_title_block">
          <span className="bwai_title_text">Rename this Trivvy?</span>
        </span>
      </ModalHeader>

      <ModalBody className="p-3">
        <div className="mt-3 mb-4">
          <Label className="bwai_label_caps">Trivvy name</Label>
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter name here"
          />
        </div>
      </ModalBody>

      <ModalFooter className="bwai_popup_footer">
        <Button className="bwai_btn_outline" onClick={() => onClose()}>Cancel</Button>
        <Button
          disabled={name && name.length < 2}
          className="bwai_btn_black"
          onClick={handleRename}
        >
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
}
